var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlusOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_165_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.51562 6.5625H7.4375V4.48437C7.4375 4.42422 7.38828 4.375 7.32812 4.375H6.67188C6.61172 4.375 6.5625 4.42422 6.5625 4.48437V6.5625H4.48437C4.42422 6.5625 4.375 6.61172 4.375 6.67188V7.32812C4.375 7.38828 4.42422 7.4375 4.48437 7.4375H6.5625V9.51562C6.5625 9.57578 6.61172 9.625 6.67188 9.625H7.32812C7.38828 9.625 7.4375 9.57578 7.4375 9.51562V7.4375H9.51562C9.57578 7.4375 9.625 7.38828 9.625 7.32812V6.67188C9.625 6.61172 9.57578 6.5625 9.51562 6.5625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 0.875C3.61758 0.875 0.875 3.61758 0.875 7C0.875 10.3824 3.61758 13.125 7 13.125C10.3824 13.125 13.125 10.3824 13.125 7C13.125 3.61758 10.3824 0.875 7 0.875ZM7 12.0859C4.1918 12.0859 1.91406 9.8082 1.91406 7C1.91406 4.1918 4.1918 1.91406 7 1.91406C9.8082 1.91406 12.0859 4.1918 12.0859 7C12.0859 9.8082 9.8082 12.0859 7 12.0859Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_165_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusOutlined);
export default __webpack_public_path__ + "static/media/icon_plus_outlined.9bdff4d8714f653c4cf5e9a17d1dab48.svg";
export { ForwardRef as ReactComponent };